import { IRunMethodResult } from "@multiweb/types/contracts";
import { ErrorHandler } from "UI/Errors";
import { InvalidArgumentException } from "../../../../../Global/Base/Exceptions";
import { EOWValidateException } from "../../../../../OW.Remoting/Basic/OWExceptions";
import { IValidationDataObject } from "../../../../../OW.Remoting/Remoting/DataTypes/IValidationDataObject";
import { OWObject } from "../../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { Localization } from "../../../../../OW.Remoting/Remoting/Localization";
import { LocalizedStringBuilder } from "../../DataBuilders/LocalizedStringBuilder";
import { MessageWindow } from "../../MessageWindow";
import { MessageButtonResult } from "../../UIManager";
import { IValidationMaster } from "../FormControl";
import { IFrame } from "../IFrame";
import { IValidationData } from "../ValidationManager";
import { SharedMethods } from "../SharedMethods";

export class ActionSharedMethods {
    /**
    * Zpracuje a zobrazí validační i ostatní chyby
    * @param error Výjimka ke zpracování
    * @param contextObject Objekt, ke kterému se mají zaznamenat případné validační chyby
    * @param owner Frame, který zpracovává případné validační chyby
    */
    public static handleErrors(error: Error, contextObject: OWObject, owner?: IFrame): void {
        if (!(error instanceof EOWValidateException)) {
            ErrorHandler.instance.handleError(error);
            return;
        }
        if (owner instanceof IValidationMaster) {
            if (contextObject == null)
                throw new InvalidArgumentException("contextObject");
            for (const ve of error.validationErrors) {
                ve.keepOnAttributeChange = true; // jinak donačítání dat po refreshi vyvolá změnu atributů a tím se odstraní validačních chyby, které nejsou navázané k atributu
                owner.validationManager.addDataError(contextObject as any as IValidationDataObject<IValidationData>, ve, []);
            }

            owner.validateAndShowMessage();
            return;
        }
        // Pokud je akce useMasterObject=true, a je položena na mainFrame, tak
        // nemá frame, ke kterému by logicky patřila, actualObjektem je masterObject formu.
        // V takovém případě jen zobrazím validační chyby.
        SharedMethods.showValidationErrors(error.validationErrors, contextObject);
    }

    /**
     * Zkontroluje, jestli byla metoda spuštěná na pozadní a pokud ano, zobrazí hlášku.
     * @internal
     */
    public static async checkMethodResult(result: IRunMethodResult, locKey?: string): Promise<MessageButtonResult> {
        if (result && result.isInLongTransaction) {
            //akce byla přesunuta na dispatcherovi a o jejím dokončení příjde interní zpráva.
            if (locKey)
                return new MessageWindow(
                    new LocalizedStringBuilder("GUI-667865", [
                        (await Localization.getLocalizationItem(locKey)).primaryText,
                    ]),
                ).show(); //Metoda '@0' byla spuštěna na pozadí. O jejím výsledku budete informování notifikací.
            else
                return new MessageWindow(
                    new LocalizedStringBuilder("GUI-667866"),
                ).show(); //Metoda byla spuštěna na pozadí. O jejím výsledku budete informování notifikací.
        }
        return Promise.resolve(null);
    }
}
